import { create } from 'zustand';
import { ExportSelection } from '@/utils/helpers/orderExport';

/**
 * BOXY-409 — one export modal for the header icon and the bottom bar.
 * The orders page mirrors its row selection here so either door opens the
 * modal on "Selected" when rows are ticked.
 */
interface ExportModalState {
  isOpen: boolean;
  selection: ExportSelection;
}

interface ExportModalActions {
  openExport: () => void;
  closeExport: () => void;
  setSelection: (selection: ExportSelection) => void;
}

export const EMPTY_EXPORT_SELECTION: ExportSelection = { uids: [], isAllSelected: false, count: 0 };

export const useExportModalStore = create<ExportModalState & ExportModalActions>((set) => ({
  isOpen: false,
  selection: EMPTY_EXPORT_SELECTION,
  openExport: () => set({ isOpen: true }),
  closeExport: () => set({ isOpen: false }),
  setSelection: (selection) => set({ selection }),
}));

type Store = ExportModalState & ExportModalActions;

export const selectIsExportOpen = (s: Store) => s.isOpen;
export const selectExportSelection = (s: Store) => s.selection;
export const selectOpenExport = (s: Store) => s.openExport;
export const selectCloseExport = (s: Store) => s.closeExport;
export const selectSetExportSelection = (s: Store) => s.setSelection;
